export default __webpack_public_path__ + "static/media/dll.d65c0ad5.jpg";